import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { NgProgress, NgProgressRef } from '@ngx-progressbar/core';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';

@Injectable()
export class ProgressInterceptor implements HttpInterceptor {
    ngProgressRef: NgProgressRef;
    count = 0;

    constructor(private ngProgress: NgProgress) {
        this.ngProgressRef = this.ngProgress.ref('root');
    }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if (request.url.indexOf('renew-check-out') !== -1) {
            return next.handle(request);
        }
        this.count += 1;
        this.ngProgressRef.start();

        return next.handle(request).pipe(finalize(() => {
            this.count -= 1;
            if (this.count === 0) {
                this.ngProgressRef.complete();
            }
        }));
    }
}
